module.exports = __webpack_public_path__ + "static/media/img2.5e7e19c8.png";